export default {
      id: "icon--bed-usage",
      viewBox: "0 0 32 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--bed-usage",
      toString: function () {
        return this.url;
      }
    }